import React, { useEffect, useState } from 'react';
import useStyles from './style';
import { Box } from '@material-ui/core';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import AdCalendarCarouselType2 from '../../../components/organism/AdCalendarCarouselType2';
import Typography from '../../../components/atoms/Typography';
import { get } from 'lodash';
import fetchService from '../../../../services/FetchService';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const Top10Events = (props) => {
  const { fields, appConfig, sitecoreContext } = props;
  const [response, setResponse] = useState('');

  const language = get(sitecoreContext, 'language', 'en');
  const title = get(props, 'rendering.fields.Title.value', '');
  const limit = get(fields, 'Limit.value', '10');
  const result = get(response, 'data.data.results', []);
  const BGColor = get(props, 'fields.bgColor.fields.colorCode.value', '#009086');
  const classes = useStyles();
  useEffect(() => {

    const topTenList = get(props, 'fields.topTenList', '');
    const getItemSlug = () => {
      const itemSlugs = topTenList
        .map(item => get(item, 'fields.urlSlug.value', ''))
        .filter(Boolean)
        .join(',');

      return itemSlugs;
    }

    const itemSlugs = getItemSlug();
    try {
      fetchService({
        url: `${appConfig.SMART_LIST_API}`,
        method: 'POST',
        data: {
          "contentType": "Event",
          "language": language,
          "facetFields": [],
          "limit": Number(limit),
          "offset": 0,
          "filters": [],
          "isPreviewMode": false,
          "ItemSlugs": itemSlugs
        }
      })
        .then(response => {
          setResponse(response)
        })
    } catch (error) {
      console.log("error", error)
    }

  }, []);

  return (
    <Box className={`${classes.Top10Events} ${BGColor ? 'withBG' : ''}`} style={{ backgroundColor: BGColor }}>
      <Typography className={'eventsTitle'} variant={'h5'}>{title}</Typography>
      <AdCalendarCarouselType2 {...props} result={result} language={language} />
    </Box>
  )
};

export default withSitecoreContext()(Top10Events);
